import IMask from 'imask';
import { getNumericLocale } from '../../locales/numeric/utils.js';
function getLocaleNumericFormat() {
    const { NUMBER_FORMAT } = getNumericLocale();
    return NUMBER_FORMAT;
}
function mergeDefaults(options = {}, defaults = {}) {
    const { DECIMAL_SEPARATOR, GROUP_SEPARATOR } = getLocaleNumericFormat();
    const { groupSize = 3, normalizeZeros = false, padFractionalZeros = false, radix = DECIMAL_SEPARATOR, scale = 3, thousandsSeparator = GROUP_SEPARATOR, } = defaults;
    return {
        groupSize,
        normalizeZeros,
        padFractionalZeros,
        radix,
        scale,
        thousandsSeparator,
        ...options,
    };
}
function getMaskOptions(options, defaults = {}) {
    const { groupSize, normalizeZeros, padFractionalZeros, radix, scale, thousandsSeparator } = mergeDefaults(options, defaults);
    return {
        groupSize,
        mapToRadix: [',', '.'],
        mask: Number,
        normalizeZeros,
        padFractionalZeros,
        radix,
        scale,
        thousandsSeparator,
    };
}
function injectCustomMethods(MaskedNumber, options) {
    const { groupSize, radix, thousandsSeparator } = options;
    //@ts-ignore
    MaskedNumber.prototype._insertThousandsSeparators = (value) => {
        const parts = value.split(radix);
        const thousandsRegex = new RegExp(`\\B(?=(\\d{${groupSize}})+(?!\\d))`, 'g');
        parts[0] = parts[0].replace(thousandsRegex, thousandsSeparator);
        return parts.join(radix);
    };
}
function isNumberValid(value, options = {}) {
    if (typeof value === 'number' && !isNaN(value)) {
        return true;
    }
    if (typeof value === 'string') {
        const { DECIMAL_SEPARATOR, GROUP_SEPARATOR } = getLocaleNumericFormat();
        const { thousandsSeparator = DECIMAL_SEPARATOR, radix = GROUP_SEPARATOR } = options;
        const sanitizedValue = removeSeparator(value, thousandsSeparator)
            .replace(radix, '.');
        return Boolean(value)
            && !value.endsWith(thousandsSeparator)
            && !value.endsWith(radix)
            && !isNaN(Number(sanitizedValue));
    }
    return false;
}
function removePrefix(value, shouldRemove = true) {
    const { CURRENCY_SYMBOL } = getLocaleNumericFormat();
    return shouldRemove ? value.replace(`${CURRENCY_SYMBOL} `, '') : value;
}
function addPrefix(value, shouldAdd = true) {
    const { CURRENCY_SYMBOL } = getLocaleNumericFormat();
    return shouldAdd ? `${CURRENCY_SYMBOL} ${value}` : value;
}
function createMask(options, defaults = {}) {
    const maskOptions = getMaskOptions(options, defaults);
    injectCustomMethods(IMask.MaskedNumber, maskOptions);
    const masked = new IMask.MaskedNumber(maskOptions);
    return { masked, options: maskOptions };
}
function appendLeftZero(value, radix) {
    return value === radix ? '0'.concat(radix) : value;
}
function removeDecimals(value, radix) {
    const [integer] = value.split(radix);
    return integer;
}
function removeSeparator(value, separator) {
    return value.replace(new RegExp(`\\${separator}`, 'g'), '');
}
export { addPrefix, appendLeftZero, createMask, getLocaleNumericFormat, getMaskOptions, injectCustomMethods, isNumberValid, mergeDefaults, removeDecimals, removePrefix, removeSeparator, };
//# sourceMappingURL=numeric-utils.js.map